import { Injectable } from '@angular/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { Moment } from 'moment';
import { DatepickerSettingModel } from './custom-date-formats';
import * as moment from 'moment';
import { EraService } from './eras.service';
import { Era } from '@app/models/date.model';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor(private eraService: EraService) {
    this.jpEras = this.eraService.getEras();
  }
  dateClass: MatCalendarCellClassFunction<Moment> = (cellDate, view) => {
    const day = cellDate.day();
    if (view === 'month') {
      switch (day) {
        case 0:
          return 'holiday';
        case 6:
          return 'saturday';
      }
    }

    return '';
  };

  // setting era name - year
  datepickerSettingModel = new DatepickerSettingModel();
  jpEras: Era[] = [];
  private _startMode: string = '';

  get startMode() {
    return this._startMode;
  }

  set startMode(value) {
    this._startMode = value;
  }

  /**
   * 
   * @returns dirty touch calendar - add era to years
   */
  castYear() {
    if (this.startMode != 'multi-year') return;
    const calendarCells = document.getElementsByClassName(`mat-calendar-body-cell-content`);
    [...[].slice.call(calendarCells)].forEach((el: HTMLElement) => {
      let year = parseInt(el.innerHTML.toString().trim()) || 0;
      if (year > 0 && !isNaN(year)) {
        let era = this.datepickerSettingModel?.findEraYear(moment().startOf('year').set({ year: year }).toDate(), this.jpEras);
        let eraString = (era?.name || '') + (year - (era?.start_year || year) + 1);
        el.style.whiteSpace = 'pre';
        el.style.lineHeight = '1rem';
        el.innerHTML = `${year}\n${eraString}`;
      }
    });
  }
}
